const CheckInSkeleton = () => {
  return (
    <div className="p-4 pb-24 animate-pulse">
      {/* Rewards Hub Card Skeleton */}
      <div className="bg-tg-secondary rounded-xl p-6 mb-6">
        <div className="h-6 bg-gray-700 rounded w-32 mb-2"></div>
        <div className="h-4 bg-gray-700 rounded w-48 mb-4"></div>
        <div className="flex items-center gap-4">
          <div className="h-8 bg-gray-700 rounded w-24"></div>
          <div className="h-6 bg-gray-700 rounded w-32"></div>
        </div>
      </div>

      {/* Daily Check-in Skeleton */}
      <div className="mb-6">
        <div className="h-6 bg-tg-secondary rounded w-40 mb-3"></div>
        <div className="grid grid-cols-3 gap-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-tg-secondary rounded-lg p-3">
              <div className="h-8 w-8 bg-gray-700 rounded mx-auto mb-2"></div>
              <div className="h-4 bg-gray-700 rounded w-16 mx-auto mb-1"></div>
              <div className="h-3 bg-gray-700 rounded w-12 mx-auto"></div>
            </div>
          ))}
        </div>
      </div>

      {/* Tasks Skeleton */}
      <div className="mb-6">
        <div className="h-6 bg-tg-secondary rounded w-24 mb-2"></div>
        <div className="h-4 bg-tg-secondary rounded w-64 mb-4"></div>
        <div className="flex gap-2 mb-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-9 bg-tg-secondary rounded-lg w-24"></div>
          ))}
        </div>
        <div className="space-y-3">
          {[1, 2].map((i) => (
            <div key={i} className="bg-tg-secondary rounded-xl p-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-700 rounded-lg"></div>
                <div className="flex-1">
                  <div className="h-4 bg-gray-700 rounded w-3/4 mb-2"></div>
                  <div className="h-3 bg-gray-700 rounded w-full mb-2"></div>
                  <div className="h-3 bg-gray-700 rounded w-2/3"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CheckInSkeleton;

